import { CountryCodes } from '@/enums/general'

export interface PaymentType {
  name: string
  value: string
  paymentType: string
  verificationAmount: number
}

export const paynlIdeal: PaymentType = {
  name: 'iDEAL',
  value: 'paynl-ideal',
  paymentType: '/api/payment_types/code/paynl-ideal',
  verificationAmount: 0.02
}

export const paynlEPS: PaymentType = {
  name: 'EPS',
  value: 'paynl-eps',
  paymentType: '/api/payment_types/code/paynl-eps',
  verificationAmount: 0.01
}

export const paypal: PaymentType = {
  name: 'PayPal',
  value: 'braintree-paypal',
  paymentType: '/api/payment_types/code/braintree-paypal',
  verificationAmount: 0
}

export const paynlBancontact: PaymentType = {
  name: 'Bancontact',
  value: 'paynl-bancontact',
  paymentType: '/api/payment_types/code/paynl-bancontact',
  verificationAmount: 0.02
}

export const paynlWero: PaymentType = {
  name: 'Wero',
  value: 'paynl-wero',
  paymentType: '/api/payment_types/code/paynl-wero',
  verificationAmount: 0.01
}

export const braintreeCreditCard: PaymentType = {
  name: 'PersonalDetails.ChoosePaymentMethod.creditcard',
  value: 'braintree-creditcard',
  paymentType: '/api/payment_types/code/braintree-creditcard',
  verificationAmount: 1.00
}

export const paynlGiropay: PaymentType = {
  name: 'PersonalDetails.ChoosePaymentMethod.giropay',
  value: 'paynl-giropay',
  paymentType: '/api/payment_types/code/paynl-giropay',
  verificationAmount: 0.01
}

export const braintreeApplePay: PaymentType = {
  name: 'PersonalDetails.ChoosePaymentMethod.applepay',
  value: 'braintree-applepay',
  paymentType: '/api/payment_types/code/braintree-applepay',
  verificationAmount: 0
}

export const braintreeGooglePay: PaymentType = {
  name: 'PersonalDetails.ChoosePaymentMethod.googlepay',
  value: 'braintree-googlepay',
  paymentType: '/api/payment_types/code/braintree-googlepay',
  verificationAmount: 0
}

export const paynlSofort: PaymentType = {
  name: 'Sofort',
  value: 'paynl-sofort',
  paymentType: '/api/payment_types/code/paynl-sofort',
  verificationAmount: 0.01
}

export const paynlMultibanco: PaymentType = {
  name: 'Multibanco',
  value: 'paynl-multibanco',
  paymentType: '/api/payment_types/code/paynl-multibanco',
  verificationAmount: 0.01
}

export const paynlPrzelewy24: PaymentType = {
  name: 'Przelewy24',
  value: 'paynl-przelewy24',
  paymentType: '/api/payment_types/code/paynl-przelewy24',
  verificationAmount: 0.01
}

export const paynlBlik: PaymentType = {
  name: 'BLIK',
  value: 'paynl-blik',
  paymentType: '/api/payment_types/code/paynl-blik',
  verificationAmount: 0.01
}

export const paynlMobilepay: PaymentType = {
  name: 'MobilePay',
  value: 'paynl-mobilepay',
  paymentType: '/api/payment_types/code/paynl-mobilepay',
  verificationAmount: 0.01
}

export const paynlVipps: PaymentType = {
  name: 'Vipps',
  value: 'paynl-vipps',
  paymentType: '/api/payment_types/code/paynl-vipps',
  verificationAmount: 0.01
}

export const paynlSwish: PaymentType = {
  name: 'Swish',
  value: 'paynl-swish',
  paymentType: '/api/payment_types/code/paynl-swish',
  verificationAmount: 0.01
}

export const paynlTwint: PaymentType = {
  name: 'TWINT',
  value: 'paynl-twint',
  paymentType: '/api/payment_types/code/paynl-twint',
  verificationAmount: 0.01
}

export const paynlBizum: PaymentType = {
  name: 'Bizum',
  value: 'paynl-bizum',
  paymentType: '/api/payment_types/code/paynl-bizum',
  verificationAmount: 0.01
}

export const paynlMbway: PaymentType = {
  name: 'MB WAY',
  value: 'paynl-mbway',
  paymentType: '/api/payment_types/code/paynl-mbway',
  verificationAmount: 0.01
}

export const paynlSatispay: PaymentType = {
  name: 'Satispay',
  value: 'paynl-satispay',
  paymentType: '/api/payment_types/code/paynl-satispay',
  verificationAmount: 0.01
}

export const revolutPay: PaymentType = {
  name: 'Revolut Pay',
  value: 'revolut-pay',
  paymentType: '/api/payment_types/code/revolut-pay',
  verificationAmount: 0
}

export const Icons = Object.freeze({
  ideal: ['ideal'],
  sepa: ['sepa'],
  'paynl-ideal': ['ideal'],
  bancontact: ['bancontact'],
  'paynl-bancontact': ['bancontact'],
  creditcard: ['visa', 'maestro', 'mastercard'],
  'braintree-creditcard': ['visa', 'mastercard'],
  paypal: ['paypal'],
  'braintree-paypal': ['paypal'],
  'paynl-eps': ['eps'],
  'paynl-giropay': ['giropay'],
  'paynl-wero': ['wero'],
  'braintree-applepay': ['apple-pay'],
  'braintree-googlepay': ['google-pay'],
  'paynl-sofort': ['sofort'],
  'paynl-multibanco': ['multibanco'],
  'paynl-przelewy24': ['przelewy24'],
  'paynl-blik': ['blik'],
  'paynl-mobilepay': ['mobilepay'],
  'paynl-vipps': ['vipps'],
  'paynl-swish': ['swish'],
  'paynl-twint': ['twint'],
  'paynl-bizum': ['bizum'],
  'paynl-mbway': ['mbway'],
  'paynl-satispay': ['satispay'],
  'revolut-pay': ['revolut-pay', 'visa', 'amex', 'mastercard']
})

export const PaymentTypesByValue: Record<string, PaymentType> = Object.freeze({
  [paynlIdeal.value]: paynlIdeal,
  [paynlEPS.value]: paynlEPS,
  [paypal.value]: paypal,
  [paynlBancontact.value]: paynlBancontact,
  [paynlWero.value]: paynlWero,
  [braintreeCreditCard.value]: braintreeCreditCard,
  [paynlGiropay.value]: paynlGiropay,
  [braintreeApplePay.value]: braintreeApplePay,
  [braintreeGooglePay.value]: braintreeGooglePay,
  [paynlSofort.value]: paynlSofort,
  [paynlMultibanco.value]: paynlMultibanco,
  [paynlPrzelewy24.value]: paynlPrzelewy24,
  [paynlBlik.value]: paynlBlik,
  [paynlMobilepay.value]: paynlMobilepay,
  [paynlVipps.value]: paynlVipps,
  [paynlSwish.value]: paynlSwish,
  [paynlTwint.value]: paynlTwint,
  [paynlBizum.value]: paynlBizum,
  [paynlMbway.value]: paynlMbway,
  [paynlSatispay.value]: paynlSatispay,
  [revolutPay.value]: revolutPay
})

export const PaymentStatuses = Object.freeze({
  open: 0,
  paid: 1,
  failed: 2,
  chargeBack: 3,
  latePayment: 4,
  pending: 5,
  refund: 6,
  paidLate: 7,
  waste: 66
})

export const PaymentDates = Object.freeze({
  [CountryCodes.austria]: 25,
  [CountryCodes.belgium]: 20,
  [CountryCodes.denmark]: 26,
  [CountryCodes.germany]: 25,
  [CountryCodes.spain]: 26,
  [CountryCodes.france]: 26,
  [CountryCodes.netherlands]: 20,
  [CountryCodes.unitedKingdom]: 26,
  [CountryCodes.sweden]: 26,
  [CountryCodes.italy]: 26,
  [CountryCodes.poland]: 26,
  [CountryCodes.switzerland]: 26,
  [CountryCodes.ireland]: 26,
  [CountryCodes.luxembourg]: 25,
  [CountryCodes.portugal]: 26,
  [CountryCodes.finland]: 26,
  [CountryCodes.norway]: 26,
  [CountryCodes.czechRepublic]: 26
})

export const BraintreeResponseTypes = Object.freeze({
  no3DSecureAvailable: 'authentication_unavailable'
})

export const PaymentFeatureFlagCookieQuery = 'ota-payment'
